module.exports = (theme) => ({
  ".button": {
    color: theme("colors.primary.black.DEFAULT"),
    backgroundColor: theme("colors.primary.yellow.DEFAULT"),
    borderWidth: theme("borderWidth.2"),
    borderColor: theme("colors.transparent"),
    borderRadius: "26px",
    fontSize: theme("fontSize.lg"),
    fontFamily: theme("fontFamily.regular"),
    fontWeight: theme("fontWeight.medium"),
    lineHeight: theme("spacing.lg"),
    paddingBottom: theme("spacing.sm"),
    paddingTop: theme("spacing.sm"),
    paddingLeft: "48px",
    paddingRight: "48px",
    marginTop: theme("margin.DEFAULT"),
    marginBottom: theme("margin.DEFAULT"),
    display: "inline-block",
    textAlign: "center",
    minWidth: "240px",
  },

  ".button.small": {
    fontSize: theme("fontSize.base"),
    lineHeight: "1.25rem",
    paddingBottom: theme("spacing.xs"),
    paddingTop: theme("spacing.xs"),
    marginTop: 0,
    marginBottom: 0,
    minWidth: "180px",
  },

  ".button.tiny": {
    fontSize: theme("fontSize.sm"),
    lineHeight: "1rem",
    paddingBottom: "0.35rem",
    paddingTop: "0.35rem",
    marginTop: 0,
    marginBottom: 0,
    minWidth: "140px",
  },

  ".button:hover": {
    backgroundColor: "#FFE85B",
    color: theme("colors.primary.black.DEFAULT"),
  },

  ".button:focus": {
    backgroundColor: "#F1C50B",
  },

  ".button::before": {
    content: '"\\2192"',
    position: "absolute",
    transformOrigin: "top left",
    transform: "translate(-220%, 0)",
    fontWeight: theme("fontWeight.medium"),
    fontSize: theme("fontSize.3xl"),
    opacity: 0,
    transitionProperty: "opacity, transform",
    transitionDuration: "300ms",
    transitionDelay: "0ms",
  },

  ".button:hover::before": {
    transitionDelay: "150ms",
    transform: "translate(-150%, 0)",
    opacity: 1,
  },

  ".button.no-arrow::before": {
    content: "none",
    transform: "none",
  },

  ".button.no-arrow:hover::before": {
    content: "none",
    transform: "none",
  },

  ".button.small::before": {
    fontSize: theme("fontSize.xl"),
  },

  ".button.small .icon::before": {
    fontSize: theme("fontSize.xl"),
    paddingRight: theme("spacing.xs"),
    lineHeight: "1.25rem",
  },

  ".button.tiny::before": {
    fontSize: theme("fontSize.base"),
  },

  ".button.tiny .icon::before": {
    fontSize: theme("fontSize.base"),
    paddingRight: theme("spacing.xs"),
    lineHeight: "1rem",
  },

  ".button[disabled]": {
    backgroundColor: "#EEEEEE !important",
    opacity: 0.65,
    color: "#767676 !important",
    cursor: "default",
  },

  ".button-secondary": {
    backgroundColor: theme("colors.primary.white"),
    color: theme("colors.primary.blue.DEFAULT"),
    borderColor: theme("colors.primary.blue.DEFAULT"),
  },

  ".button-secondary:hover": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
  },

  ".button-secondary:focus": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
  },
  ".button-expand": {
    backgroundColor: "transparent",
    padding: "1rem",
    textAlign: "left",
    width: "auto",
    minWidth: "unset",
  },
  ".button-expand::before": {
    content: "unset",
  },
  ".button-expand:focus": {
    backgroundColor: "transparent",
  },
  ".button-expand:hover": {
    position: "relative",
    backgroundColor: "transparent",
  },
  ".button-expand::after": {
    content: '"\\e981"',
    fontFamily: theme("fontFamily.icons"),
    fontSize: theme("fontSize.lg"),
    paddingLeft: "1rem",
    verticalAlign: "middle",
  },
  ".button-expand[active]::after": {
    content: '"\\e98c"',
  },
  ".button-blue": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
  },
  ".button-blue:hover": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
  },
  ".button-blue:focus": {
    backgroundColor: theme("colors.secondary.darkblue.DEFAULT"),
  },
  ".button-text": {
    backgroundColor: theme("colors.primary.white"),
    color: theme("colors.primary.black.DEFAULT"),
    minWidth: "auto !important",
    paddingLeft: "0.5rem !important",
    paddingRight: "0rem !important",
  },

  ".button-text:hover": {
    backgroundColor: theme("colors.primary.white"),
    color: theme("colors.primary.blue.DEFAULT"),
  },

  ".button-text:focus": {
    backgroundColor: theme("colors.primary.white"),
    color: theme("colors.primary.blue.DEFAULT"),
  },
  ".button-text::before": {
    opacity: 1,
  },
});
